export const Section = {
  "background-color": "color",
  "background-url": "string",
  "background-repeat": "enum(repeat,no-repeat)",
  "background-size": "string",
  "background-position": "string",
  "background-position-x": "string",
  "background-position-y": "string",
  border: "string",
  "border-bottom": "string",
  "border-left": "string",
  "border-radius": "string",
  "border-right": "string",
  "border-top": "string",
  direction: "enum(ltr,rtl)",
  "full-width": "enum(full-width,false,)",
  padding: "unit(px,%){1,4}",
  "padding-top": "unit(px,%)",
  "padding-bottom": "unit(px,%)",
  "padding-left": "unit(px,%)",
  "padding-right": "unit(px,%)",
  "text-align": "enum(left,center,right)",
};
